import {makeAutoObservable} from 'mobx';
import {LINO_OPTIONS} from './lino-options';

class LinoGirlScoutsAutographStore {
    public stateOptions: string[] = [];
    public selectedState: string;
    public productImageUrl: string = LINO_OPTIONS[0].productImageUrl;

    constructor() {
        makeAutoObservable(this);
    }

    getData() {
        const options = LINO_OPTIONS.flatMap(i =>
            i.state
                .split(',')
                .filter(i => i !== '-1')
                .map(item => item.trim()),
        ).sort();

        this.stateOptions = [...new Set(options)];
    }

    setSelected(state: string) {
        this.selectedState = state;
    }

    get nameOptionsFiltered() {
        return this.selectedState ? LINO_OPTIONS.filter(i => i.state.toLowerCase() === this.selectedState.toLowerCase()).sort((a, b) => a.title.localeCompare(b.title)) : [];
    }
}

export const linoGirlScoutsAutographStore = new LinoGirlScoutsAutographStore();
